export default __webpack_public_path__ + "static/cita-plugin-df03df1bb31865dc47208a737b0f9f85.png";